import React from 'react';
import { useSelector } from 'react-redux';
import { useAppSelector } from '../../hooks/use-app-selector';
import { PromoteDownPayments } from './PromoteDownPayments';
import { getCookie } from '../../utils/cookies';
import { keys as queryKeys } from '../../queries';
import { useGlobals } from '../../globals-context';

type PaymentStatus = string;

interface PaymentMethod {
  name: string;
  status: PaymentStatus;
}

interface PaymentSettings {
  paymentMethods?: PaymentMethod[];
}

// TODO:max I think the local type here is not accurate or it was not accurately typed in the past. I updated it to match type of currentMerchant
interface Merchant {
  id: string | null;
  paymentSettings?: PaymentSettings | null;
  whiteLabel?: string | null;
  createdAt: string | null;
  currency?: string | null;
  subscriptionStatus?: string;
}

interface Account {
  isKeyAccount?: boolean | null;
}

const EUROPEAN_CURRENCIES = new Set([
  'CHF',
  'CZK',
  'DKK',
  'EUR',
  'GBP',
  'HUF',
  'NOK',
  'PLN',
  'RON',
  'SEK',
]);

function isBannerVisible(): boolean {
  const showBannerCookie = getCookie('showPromoteDownPayments');

  if (showBannerCookie !== null) {
    return showBannerCookie === 'true';
  }

  return true;
}

function isEligibleForPromotion(
  currentAccount: Account,
  currentMerchant: Merchant,
  queryClient: any
): boolean {
  const methods = currentMerchant.paymentSettings?.paymentMethods ?? [];

  const isPayOnlineActivated = methods.some(
    (m) => m?.name === 'shorepay_online' && m?.status === 'active'
  );

  const isWhitelabel =
    currentMerchant.whiteLabel !== null &&
    currentMerchant.whiteLabel !== 'shore';

  const isKeyAccount = Boolean(currentAccount?.isKeyAccount);

  const currency = currentMerchant.currency?.toUpperCase();
  const isMerchantFromEurope = currency
    ? EUROPEAN_CURRENCIES.has(currency)
    : false;

  const hasPaidSubscription = currentMerchant.subscriptionStatus === 'active';

  /* eslint-disable prettier/prettier */
  const hasChargebeeSubscription = Boolean(
    currentMerchant.id &&
      queryClient?.getQueryData(
        queryKeys?.subscription.latest(currentMerchant?.id)
      )
  );
  /* eslint-enable prettier/prettier */

  return (
    !isPayOnlineActivated &&
    !isWhitelabel &&
    !isKeyAccount &&
    isMerchantFromEurope &&
    hasPaidSubscription &&
    hasChargebeeSubscription
  );
}

function shouldShowPromoteDownPayments(
  currentAccount: Account,
  currentMerchant: Merchant,
  queryClient: any
): boolean {
  try {
    return (
      isBannerVisible() &&
      isEligibleForPromotion(currentAccount, currentMerchant, queryClient)
    );
  } catch (error) {
    console.error(
      'Error in fetching data to show promote pay online banner:',
      error
    );
    return false;
  }
}

export function Banners() {
  const { queryClient } = useGlobals() as any;
  const currentAccount = useSelector((state: any) => state.currentAccount);
  const currentMerchant = useAppSelector((state) => state.currentMerchant);

  return (
    <div>
      {shouldShowPromoteDownPayments(
        currentAccount,
        currentMerchant,
        queryClient
      ) && <PromoteDownPayments />}
    </div>
  );
}
